import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { MainListItems } from "./listItems";
import Dashboard from "./Dashboard";
import Users from "./Users";
import Visits from "./Visits";
import Incidents from "./Incidents";
import Customers from "./Customers";
import Journal from "./Journal";
import Claims from "./Claims";
import AddUser from "./AddUser";
import EditUser from "./EditUser";
import EditIncidents from "./EditIncidents";
import EditCustomer from "./EditCustomer";
import AddNewAccount from "./AddNewAccount";
import AddClaims from "./AddClaims";
import EditClaims from "./EditClaims";
import VisitDetails from "./VisitDetails";
import Request from "./Request";
import EditRequest from "./EditRequests";
import LogHistory from "./LogHistory";
import LogDetails from "./LogDetails";
import InSite from "./InSite";
import { Switch, Route } from "react-router-dom";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://www.sayeretgroup.net/">
        Sayeret
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    marginRight: "auto",
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    color: "#000",
    alignSelf: "center",
    fontSize: 38,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },

  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function DrawerContainer() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div
      style={{
        background: `url('https://firebasestorage.googleapis.com/v0/b/sayeret-1aba9.appspot.com/o/fondodos.jpg?alt=media&token=2e0c8187-3749-4bf0-99bd-6099fb0d534d') no-repeat center center fixed`,
        backgroundSize: "cover",
        /* Full height */
        height: dimensions.height,
        width: dimensions.width,

        zIndex: 1,
      }}
    >
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={clsx(classes.appBar, open && classes.appBarShift)}
        >
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(
                classes.menuButton,
                open && classes.menuButtonHidden
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              SAYERET SECURITY
            </Typography>
            {/*
            <IconButton color="inherit">
              <Badge badgeContent={4} color="secondary">
                <NotificationsIcon style={{ color: "#fff" }} />
              </Badge>
            </IconButton>*/}
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <div>
              <Typography
                style={{
                  fontStyle: "italic",
                  fontSize: 16,
                  alignSelft: "center",
                  textAlign: "center",
                }}
              >
                "Somos Su Aliado en
              </Typography>
              <Typography
                style={{
                  fontStyle: "italic",
                  fontSize: 16,
                  alignSelft: "center",
                  textAlign: "center",
                }}
              >
                Seguridad"
              </Typography>
            </div>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>

          <Divider />
          <List>
            <MainListItems />
          </List>

          <img
            src="https://firebasestorage.googleapis.com/v0/b/sayeret-1aba9.appspot.com/o/logosayeret.png?alt=media&token=03981e8e-26c3-42b6-87b7-1cefa31f7bd1.png"
            style={{
              width: open ? 80 : 40,
              height: open ? 80 : 40,
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: 10,
              marginBottom: 10,
            }}
          />
          <Divider />
          <div
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: 20,
              display: "flex",
              lineHeight: "40px",
            }}
          >
            <img
              src="https://firebasestorage.googleapis.com/v0/b/sayeret-1aba9.appspot.com/o/customer-service.png?alt=media&token=8490e88b-983f-485f-8455-b3db8a946f79"
              style={{ width: 30, height: 30, marginLeft: open ? 20 : 0 }}
            />
            <span
              style={{
                fontSize: 16,
                fontWeight: "bold",
                marginLeft: 10,
                display: open ? "block" : "none",
              }}
            >
              +507.209.0254
            </span>
          </div>
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Switch>
              <Route path={`/users`}>
                <Users />
              </Route>
              <Route path={`/insite`}>
                <InSite />
              </Route>
              <Route path={`/visits`}>
                <Visits />
              </Route>
              <Route path={`/incidents`}>
                <Incidents />
              </Route>
              <Route path={`/customers`}>
                <Customers />
              </Route>
              <Route path={`/assistance`}>
                <Journal />
              </Route>
              <Route path={`/claims`}>
                <Claims />
              </Route>
              <Route path={`/adduser`}>
                <AddUser />
              </Route>
              <Route path={`/edituser:id`}>
                <EditUser />
              </Route>
              <Route path={`/logdetails:id`}>
                <LogDetails />
              </Route>
              <Route path={`/editincidents:id`}>
                <EditIncidents />
              </Route>
              <Route path={`/editclaims:id`}>
                <EditClaims />
              </Route>
              <Route path={`/editcustomer:id`}>
                <EditCustomer />
              </Route>
              <Route path={`/addclaims`}>
                <AddClaims />
              </Route>
              <Route path={`/addcustomer`}>
                <AddNewAccount />
              </Route>
              <Route path={`/requests`}>
                <Request />
              </Route>
              <Route path={`/visitdetails:id`}>
                <VisitDetails />
              </Route>
              <Route path={`/editrequests:id`}>
                <EditRequest />
              </Route>
              <Route path={`/loghistory`}>
                <LogHistory />
              </Route>
              <Route path={`/`}>
                <Dashboard />
              </Route>
            </Switch>
          </Container>
        </main>
        <Copyright />
      </div>
    </div>
  );
}
